import {Component} from "@angular/core";
import {ActivatedRoute, Router} from "@angular/router";
import {WorkflowService} from "../workflow.service";
import {DeploymentWorkflowService} from "./deployment-workflow.service";
import {WorkflowStep} from "../workflow-step";
import {exposeComponentInDebugMode} from "../../misc/expose-component-in-debug-mode.decorator";

@Component({
  templateUrl: "./itsm-deployed-assets-report.template.pug",
  providers: [DeploymentWorkflowService],
})
@exposeComponentInDebugMode()
export class ItsmDeployedAssetsReportComponent extends WorkflowStep {
  disableStep: boolean = false;
  error: Error;
  disableAll: boolean = false;
  deploymentId: string = "";
  isFileDownloading = false;

  ready() {
    this.error = undefined;
    this.loadData();
  }

  private async loadData(): Promise<void> {
    if (!this.workflowTargetInfo.targetId) return;
    this.deploymentId = this.workflowTargetInfo.targetId;
  }

  constructor(
    public route: ActivatedRoute,
    public router: Router,
    public workflowService: WorkflowService,
  ) {
    super();
  }
}
